import { useTranslation } from "react-i18next";
import {
  ChallengeCardWrapper,
  ChallengeHeader,
  ChallengeLiveBadge,
  ChallengeAmount,
} from "./ChallengeUtils";
import { ChallengeInfoProps } from "@/pages/challenges/ChallengeInfo";

export const ChallengeLiveCard = ({
  targetAmount,
  youtubeLink,
}: ChallengeInfoProps) => {
  const { t } = useTranslation();

  return (
    <ChallengeCardWrapper>
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <ChallengeHeader
              text={t("challenge.challenge_result_determining")}
              textColor="text-green"
            />
            {youtubeLink && <ChallengeLiveBadge youtubeLink={youtubeLink} />}
          </div>
          {targetAmount && <ChallengeAmount amount={targetAmount} />}
        </div>
      </div>
    </ChallengeCardWrapper>
  );
};
